import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { format } from "date-fns";
import NotificationSnackbar from "../../../common/notificationBar/notification-snackbar";

const TaskHistoryExport = ({ filteredTasks }) => {
  const [openExportSnackbar, setExportOpenSnackbar] = useState(false);

  // PDF export function
  const handleExportToPDF = () => {
    // Create a new jsPDF instance
    const doc = new jsPDF();

    // Set document title
    doc.setFontSize(18);
    doc.text("Task History Report", 14, 20); // Title at coordinates (14, 20)

    // Add a table to the PDF
    const tableData = filteredTasks.map((task) => [
      task.taskName,
      task.shiftType,
      task.status,
      format(new Date(task.updated_at), "dd MMM yyyy"),
      task.updated_by,
    ]);

    // Define column headers for the table
    const headers = [["Task Name", "Work Shift", "Status", "Updated", "Updated By"]];

    // Use autoTable plugin to generate a table
    autoTable(doc, {
      head: headers,
      body: tableData,
      startY: 30, // Start drawing the table from Y position 30
    });

    // Save the generated PDF
    const currentDate = new Date();
    const formattedDate = format(currentDate, "dd MMM yyyy");
    const fileName = `task-history-report-${formattedDate}.pdf`;

    doc.save(fileName);
    setExportOpenSnackbar(true);
  };

  return (
    <Box>
      {/* Title */}
      <Typography variant='subtitle1' sx={{ fontSize: "18px", fontWeight: "bold" }} align='left'>
        Sub tasks
      </Typography>

      {/* Subtitle */}
      <Typography variant='body2' sx={{ fontSize: "14px", mb: 3 }} align='left'>
        Select the export button you would like to export the current view table
      </Typography>

      {/* Export Button */}
      <Button
        variant='contained'
        color='primary'
        onClick={handleExportToPDF}
        sx={{
          width: "100%",
          textTransform: "none",
        }}
      >
        Export
      </Button>
      <NotificationSnackbar
        open={openExportSnackbar}
        onClose={() => setExportOpenSnackbar(false)}
        color='success'
        message='Task List Export Successfully. '
      />
    </Box>
  );
};

export default TaskHistoryExport;
